import { Button, Modal } from "antd";
import React, { useEffect, useRef, useState } from "react";
import WebUtils from "../../utils/WebUtils";
import { endInterviewApi } from "../../../api";
import Icon from "../../../assets/Icon";

function EndInterviewRequestModal({
  socket,
  endInterviewRequestModal,
  setEndInterviewRequestModal,
  interviewData,
  setLoading,
  videoBlobQueueRef,
  screenShareBlobQueueRef,
  timeRemainingRef,
  chatMessagesRef,
  ip,
  stopRecording,
  allowUnloadRef
}) {
  const [logCode, setLogCode] = useState("End interview requested");
  const [logMessage, setLogMessage] = useState(
    "End interview requested and ended successfully",
  );
  const endInterviewFlag = useRef(false);
  const endIntervalRef = useRef(null);

  const endInterviewFunc = () => {
    setLoading(true);
    if (
      videoBlobQueueRef.current.length === 0 &&
      screenShareBlobQueueRef.current.length === 0 &&
      endInterviewFlag.current
    ) {
      setLoading(false);
      clearInterval(endIntervalRef.current);
      allowUnloadRef.current = true
      window.location.href = `/interview-completed?interviewId=${interviewData?.interviewId}`;
      return;
    }
  };
  let logs = WebUtils.logData();
  const callEndInterviewApi = () => {
    let url = endInterviewApi;

    let browserData = navigator;
    const logBody = {
      ...logs,
      role: interviewData?.userRole,
      name: interviewData?.name,
      ip: ip,
      //   dateTimeInfo: new Date().toISOString().slice(0, -5),
      logCode: logCode,
      logMessage: logMessage,
    };

    const requestBody = {
      interviewId: interviewData?.interviewId,
      ipLog: logBody,
      interviewType: interviewData?.interviewType,
      timeLeft: timeRemainingRef.current,
      interviewConversation: chatMessagesRef.current,
    };

    WebUtils.httpOperations(url, requestBody, "POST")
      .then((result) => {
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
        }
        endInterviewFlag.current = true;
      })
      .catch((err) => {
        endInterviewFlag.current = true;
        console.log(err);
      });
  };

  return (
    <Modal
      className="rejoin-modal"
      open={endInterviewRequestModal}
      onCancel={() => {
        setEndInterviewRequestModal(false);
        socket.emit("continueInterviewRequested");
      }}
      centered
      footer={null}
    >
      <div className="">
        <Icon type="warning-icon" width="45" height="45" />
      </div>
      <div className="mt-[.55rem] font-semibold text-[1.05rem] text-[#101828]">
        End Interview Requested{" "}
      </div>

      <p className="text-[.96rem] mt-3 text-[#475467]">
        You have requested to end the interview. You can continue the interview
        or confirm below to end the interview.
      </p>

      <div className="flex flex-col sm:flex-row gap-[.45rem] justify-center mt-6 items-center">
        <Button
          type="primary"
          onClick={() => {
            setEndInterviewRequestModal(false);
            socket.emit("continueInterviewRequested");
          }}
          size="large"
          className="w-full sm:w-[49%] text-[.98rem]"
        >
          Continue Interview
        </Button>
        <Button
          type="primary"
          danger
          className="w-full sm:flex-1 px-5 text-[.98rem]"
          size="large"
          onClick={() => {
            stopRecording();
            callEndInterviewApi();
            endIntervalRef.current = setInterval(endInterviewFunc, 500);
          }}
        >
          End Inteview
        </Button>
      </div>
    </Modal>
  );
}

export default EndInterviewRequestModal;
